module.exports = __webpack_public_path__ + "img/cns_pc29.6d018ad3.png";